import { render } from "./notificationelement.vue?vue&type=template&id=4221a272"
import script from "./notificationelement.vue?vue&type=script&lang=js"
export * from "./notificationelement.vue?vue&type=script&lang=js"

import "./notificationelement.vue?vue&type=style&index=0&id=4221a272&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__